import { z } from "zod";
import { CurrencyEnum, ServiceRequestUnitEnum, ServiceRequestTypeEnum } from "../enum/service.enum";

export const createContractContractDetailsSchema = z.object({
  description: z.string({ required_error: "DESCRIPTION_REQUIRED" }).min(1, "DESCRIPTION_REQUIRED"),
  paymentConfig: z
    .object({
      amount: z.coerce.number({ required_error: "AMOUNT_REQUIRED" }).min(1, "AMOUNT_MUST_BE_GREATER_THAN_0"),
      currency: z.nativeEnum(CurrencyEnum),
      type: z.nativeEnum(ServiceRequestTypeEnum),
      paymentDueDate: z
        .string({ required_error: "PAYMENT_DUE_DATE_REQUIRED" })
        .datetime({ message: "PAYMENT_DUE_DATE_REQUIRED" })
        .optional(),
      unit: z.nativeEnum(ServiceRequestUnitEnum).nullable(),
    })
    .refine(
      (data) => {
        if (data.type === "fixed") {
          return !!data.paymentDueDate;
        }
        return true;
      },
      {
        message: "PAYMENT_DUE_DATE_REQUIRED",
        path: ["paymentDueDate"],
      }
    ),
});

const createContractMilestoneSchema = z.object({
  name: z.string({ required_error: "MILESTONE_NAME_REQUIRED" }).min(1, "MILESTONE_NAME_REQUIRED"),
  deliveryDueDate: z
    .string({ required_error: "DELIVERY_DUE_DATE_REQUIRED" })
    .datetime({ message: "DELIVERY_DUE_DATE_REQUIRED" })
    .optional(),
  paymentDueDate: z
    .string({ required_error: "PAYMENT_DUE_DATE_REQUIRED" })
    .datetime({ message: "PAYMENT_DUE_DATE_REQUIRED" })
    .optional(),
});

export const createContractMilestoneDetailsSchema = z.object({
  milestones: z.array(createContractMilestoneSchema).min(1, "MILESTONES_REQUIRED").max(50, "MILESTONES_MAX_50"),
  termsAndConditions: z.boolean({ required_error: "TERMS_AND_CONDITIONS_REQUIRED" }),
});

export const createContractSchema = z
  .object({
    serviceRequestId: z.number(),
  })
  .merge(createContractContractDetailsSchema)
  .merge(createContractMilestoneDetailsSchema);
